import { Component, Input, HostBinding, ChangeDetectionStrategy,
         ViewChild, ElementRef, AfterContentInit } from '@angular/core';
export type TdNotificationCountPositionY = number;
export let TdNotificationCountPositionY: any = {};
TdNotificationCountPositionY.Top =  /** @type {?} */(( <any>'top'));
TdNotificationCountPositionY.Bottom =  /** @type {?} */(( <any>'bottom'));
TdNotificationCountPositionY.Center =  /** @type {?} */(( <any>'center'));
TdNotificationCountPositionY[TdNotificationCountPositionY.Top] = "Top";
TdNotificationCountPositionY[TdNotificationCountPositionY.Bottom] = "Bottom";
TdNotificationCountPositionY[TdNotificationCountPositionY.Center] = "Center";

export type TdNotificationCountPositionX = number;
export let TdNotificationCountPositionX: any = {};
TdNotificationCountPositionX.Before =  /** @type {?} */(( <any>'before'));
TdNotificationCountPositionX.After =  /** @type {?} */(( <any>'after'));
TdNotificationCountPositionX.Center =  /** @type {?} */(( <any>'center'));
TdNotificationCountPositionX[TdNotificationCountPositionX.Before] = "Before";
TdNotificationCountPositionX[TdNotificationCountPositionX.After] = "After";
TdNotificationCountPositionX[TdNotificationCountPositionX.Center] = "Center";

export class TdNotificationCountComponent implements AfterContentInit {
private _notifications: number | boolean = 0;
private _positionY: TdNotificationCountPositionY;
private _positionX: TdNotificationCountPositionX;
/**
 * Div content wrapper of `ng-content`.
 */
content: ElementRef;
/**
 * color?: "primary" | "accent" | "warn"
 * Sets the theme color of the notification tip. Defaults to "warn"
 */
color: 'primary' | 'accent' | 'warn' = 'warn';
/**
 * positionX?: TdNotificationCountPositionX or "before" | "after" | "center"
 * Sets the X position of the notification tip.
 * Defaults to "after" if it has content, else 'center'.
 * @param {?} positionX
 * @return {?}
 */
set positionX(positionX: TdNotificationCountPositionX) {
    this._positionX = positionX;
  }
/**
 * @return {?}
 */
get positionX(): TdNotificationCountPositionX {
    return this._positionX;
  }
/**
 * positionY?: TdNotificationCountPositionY or "top" | "bottom" | "center"
 * Sets the Y position of the notification tip.
 * Defaults to "top" if it has content, else 'center'.
 * @param {?} positionY
 * @return {?}
 */
set positionY(positionY: TdNotificationCountPositionY) {
    this._positionY = positionY;
  }
/**
 * @return {?}
 */
get positionY(): TdNotificationCountPositionY {
    return this._positionY;
  }
/**
 * notifications?: number | boolean
 * Number for the notification count. Shows component only if the input is a positive number or 'true'
 * @param {?} notifications
 * @return {?}
 */
set notifications(notifications: number | boolean) {
    this._notifications = notifications;
  }
/**
 * @return {?}
 */
get hideHost(): boolean {
    return !this.show && !this._hasContent();
  }
/**
 * Sets the component in its 'noCount' state if [notifications] is a boolean 'true'.
 * Makes the notification tip show without a count.
 * @return {?}
 */
get noCount(): string | boolean {
    return this._notifications === true;
  }
/**
 * Notification display string when a count is available.
 * Anything over 99 gets set as 99+
 * @return {?}
 */
get notificationsDisplay(): string {
    if (this._notifications > 99) {
      return '99+';
    }
    return this._notifications.toString();
  }
/**
 * Shows notification tip only when [notifications] is true or a positive integer.
 * @return {?}
 */
get show(): boolean {
    return this._notifications === true || (!isNaN( /** @type {?} */((<any>this._notifications))) && this._notifications > 0);
  }
/**
 * Check if [positionX] and [positionY] have been set as inputs, else use defaults depending on component content.
 * @return {?}
 */
ngAfterContentInit(): void {
    if (!this._positionX) {
      this.positionX = this._hasContent() ? TdNotificationCountPositionX.After : TdNotificationCountPositionX.Center;
    }
    if (!this._positionY) {
      this.positionY = this._hasContent() ? TdNotificationCountPositionY.Top : TdNotificationCountPositionY.Center;
    }
  }
/**
 * Method to check if element has any kind of content (elements or text)
 * @return {?}
 */
private _hasContent(): boolean {
    if (this.content) {
      let /** @type {?} */ contentElement: HTMLElement = this.content.nativeElement;
      return contentElement && (contentElement.children.length > 0 || !!contentElement.textContent.trim());
    }
    return false;
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'td-notification-count',
  styleUrls: ['./notification-count.component.css' ],
  templateUrl: './notification-count.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'content': [{ type: ViewChild, args: ['content', ] },],
'color': [{ type: Input },],
'positionX': [{ type: Input },],
'positionY': [{ type: Input },],
'notifications': [{ type: Input },],
'hideHost': [{ type: HostBinding, args: ['class.td-notification-hidden', ] },],
};
}

function TdNotificationCountComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdNotificationCountComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdNotificationCountComponent.ctorParameters;
/** @type {?} */
TdNotificationCountComponent.propDecorators;
/** @type {?} */
TdNotificationCountComponent.prototype._notifications;
/** @type {?} */
TdNotificationCountComponent.prototype._positionY;
/** @type {?} */
TdNotificationCountComponent.prototype._positionX;
/**
 * Div content wrapper of `ng-content`.
 * @type {?}
 */
TdNotificationCountComponent.prototype.content;
/**
 * color?: "primary" | "accent" | "warn"
 * Sets the theme color of the notification tip. Defaults to "warn"
 * @type {?}
 */
TdNotificationCountComponent.prototype.color;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
